<template>
  <form id="search" class="search">
    <input
      type="text"
      name="query"
      @input="$emit('input', $event.target.value)"
      :value="value"
      class="form-control"
      placeholder="Search"
    />
    <button
      v-if="value"
      @click="$emit('input', '')"
      class="clear"
    ><i class="fas fa-times-circle" /></button>
  </form>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
  },

  methods: {
    name() {

    },
  },
};
</script>
